import axios from "axios";
import { apiUrl, execUrl } from "libs/commonVar";
import * as common from "libs/commonFunc";

//const execUrl = execUrl + 'admin/';

export const apiGet = (url, params) =>
  common.requestRaw(apiUrl + url, params, "get");
export const apiPost = (url, params) =>
  common.requestRaw(apiUrl + url, params, "post");
export const apiPut = (url, params) =>
  common.requestRaw(apiUrl + url, params, "put");
export const apiDelete = (url, params) =>
  common.requestRaw(apiUrl + url, params, "delete");

export const execGet = (url, params) =>
  common.requestRaw(execUrl + url, params, "get");
export const execPost = (url, params) =>
  common.requestRaw(execUrl + url, params, "post");
export const execPut = (url, params) =>
  common.requestRaw(execUrl + url, params, "put");
export const execDelete = (url, params) =>
  common.requestRaw(execUrl + url, params, "delete");

export const editPassword = (params) =>
  common.requestRaw(apiUrl + "Admin/AdminEditPasswd", params, "put");
export const adminInitSetting = (params) =>
  common.requestRaw(apiUrl + "Admin/InitSetting", params, "put");

export const getSystemConfigAll = () => {
  return execGet("SystemConfig");
};

export const getSystemConfigBasic = () => {
  return execGet("SystemConfig", { category: "basic" });
};

export const getSystemConfigSmtp = () => {
  return execGet("SystemConfig", { category: "smtp" });
};

export const getSystemConfigSync = () => {
  return execGet("SystemConfig", { category: "sync" });
};

export const postSync = () => {
  return apiPost("Sync");
};

export const postSyncTest = (params) => {
  return apiPost("Sync/Test", params);
};

export function updateSystemConfig(params) {
  return axios({
    method: "put",
    url: execUrl + "SystemConfig",
    params: params,
  });
}

export function SystemConfigInitBasic() {
  return axios({
    method: "put",
    url: execUrl + "SystemConfigInit",
    params: { category: "basic" },
  });
}

export function SystemConfigInitSmtp() {
  return axios({
    method: "put",
    url: execUrl + "SystemConfigInit",
    params: { category: "smtp" },
  });
}

export const getSystemLog = (params) => {
  return apiGet("SystemLog", params);
};

export const getSystemLogdetail = (params) => {
  return apiGet("SystemLog/Detail", params);
};

export function systemLogDownload(params) {
  return axios({
    method: "post",
    params: params,
    headers: {
      "Content-Type": "application/vnd.openxmlformats",
    },
    responseType: "arraybuffer",
    url: apiUrl + "SystemLog/Download",
  });
}

export const getUser = (params) => {
  return apiGet("User", params);
};

export const addUser = (params) => {
  return apiPost("User", params);
};

export const deleteUser = (params) => {
  return apiDelete("User", params);
};

export const accessUserPut = (params) => {
  return apiGet("User/AccessUserPut", params);
};

export const uploadExamTemplateAttachFile = (formData) => {
  return axios({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: apiUrl + "Template/UploadFile",
    data: formData,
  });
};



// WEBPACK FOOTER //
// ./src/script/libs/adminLib.js